module.exports = __webpack_public_path__ + "static/lavoraconnoi_hero-9f019e5672205a0a4b497cb846d20922.jpg";